
export async function isContractAddress(
  address: string, 
  publicClient: any
): Promise<boolean> {
  try {
    // 使用 viem 获取地址的代码
    const code = await publicClient.getCode({
      address: address,
    });

    // 如果代码存在且不为空，则是合约地址
    return code !== '0x' && code !== '0x0' && code !== undefined && code !== null;
  } catch (error) {
    console.error('Error checking contract address:', error);
    return false;
  }
}